import { useMutation } from '@apollo/client';
import { MeData } from 'graphQL/Auth/types';
import { useUserInformation } from 'graphQL/Zustand/useUserInformation';
import { CHANGE_HOST_PERSONAL_PHONE_NUMBER } from '..';
import { useGetMe } from 'graphQL/Auth/user/useGetMe';

export function useMutationChangeHostPersonalPhoneNumber() {
  const myInfo: MeData = useUserInformation((state: any) => state.userInfo);
  const { handleRefetchUser } = useGetMe();

  const [changeHostPersonalPhoneNumber] = useMutation(
    CHANGE_HOST_PERSONAL_PHONE_NUMBER,
  );

  const handleChangeHostPersonalPhoneNumber = async (
    phoneNumber: string,
    callback?: () => void,
  ) => {
    try {
      const response = await changeHostPersonalPhoneNumber({
        variables: {
          hostId: myInfo.me.host.id,
          phoneNumber: phoneNumber,
        },
      });

      if (response) {
        callback && callback();
        handleRefetchUser();
      }
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  return { handleChangeHostPersonalPhoneNumber };
}
